import React from "react";
const ProjectsHero = () => <section>hey i'm ProjectsHero</section>;
export default ProjectsHero;
